import React from 'react';

const RetentionTableSkeleton: React.FC = () => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm p-6 border border-gray-100 dark:border-gray-700 relative overflow-hidden">
      <div className="flex items-center justify-between mb-6">
        <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-40 shimmer"></div>
        <div className="flex items-center gap-3">
          <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-xl w-44 shimmer"></div>
          <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-xl w-24 shimmer"></div>
        </div>
      </div>
      
      {/* Summary Cards */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4 border border-blue-200 dark:border-blue-800">
            <div className="h-3 bg-blue-200 dark:bg-blue-800 rounded w-3/4 mb-2 shimmer"></div>
            <div className="h-6 bg-blue-200 dark:bg-blue-800 rounded w-1/2 shimmer"></div>
          </div>
        ))}
      </div>

      {/* Table Skeleton */}
      <div className="overflow-x-auto">
        <table className="w-full text-xs border-collapse">
          <thead>
            <tr className="bg-gray-50 dark:bg-gray-700">
              <th className="px-3 py-2 border border-gray-200 dark:border-gray-600">
                <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-16 shimmer"></div>
              </th>
              {Array.from({ length: 30 }).map((_, i) => (
                <th key={i} className="px-2 py-2 border border-gray-200 dark:border-gray-600">
                  <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-8 mx-auto shimmer"></div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 8 }).map((_, rowIndex) => (
              <tr key={rowIndex}>
                <td className="px-3 py-2 border border-gray-200 dark:border-gray-600">
                  <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-20 shimmer"></div>
                </td>
                {Array.from({ length: 30 }).map((_, colIndex) => (
                  <td key={colIndex} className="px-2 py-2 border border-gray-200 dark:border-gray-600">
                    <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-12 mx-auto shimmer"></div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      <style>{`
        @keyframes shimmer {
          0% {
            background-position: -1000px 0;
          }
          100% {
            background-position: 1000px 0;
          }
        }
        
        .shimmer {
          background: linear-gradient(
            90deg,
            #f0f0f0 0%,
            #e0e0e0 20%,
            #f0f0f0 40%,
            #f0f0f0 100%
          );
          background-size: 1000px 100%;
          animation: shimmer 2s infinite linear;
        }
        
        .dark .shimmer {
          background: linear-gradient(
            90deg,
            #374151 0%,
            #4b5563 20%,
            #374151 40%,
            #374151 100%
          );
          background-size: 1000px 100%;
          animation: shimmer 2s infinite linear;
        }
      `}</style>
    </div>
  );
};

export default RetentionTableSkeleton;

